import { ServiceFrequency, ServiceStatusEnum, SiteWarehouse } from "@gtpl/shared-models/common-models";
import { AssetStatusEnum } from "libs/shared-models/common-models/src/lib/enum/asset-status.enum";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { AssetAssignment } from "../asset-assignment/entity/asset-assignment.entity";
import { AssetLocationMapping } from "../asset-location-mapping/entity/asset-location-mapping.entity";
import { AssetMaintainance } from "../asset-maintainance/entity/asset-maintainance.entity";
import { AssetsCatagory } from "../assets-catagory/assets-catagory-entity";
import { AssetsClassification } from "../assets-classification/assets-classification-entity";
import { AssetsSubCatagory } from "../assets-sub-catagory/assets-sub-catagory-entity";



@Entity('assets')
export class Assets {

    @PrimaryGeneratedColumn("increment", { name: 'asset_id' })
    assetId: number;

    @Column("int", {
        nullable: false,
        name: "assets_name"
    })
    assetsName: number;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "assets_code"
    })
    assetsCode: string;

    @Column("varchar", {
        name: "asset_serialno"
    })
    assetSerialNo: string;

    @Column("int", {
        nullable: false,
        name: "item_id"
    })
    itemId: number;

    @Column("int", {
        name: "grn_id"
    })
    grnId: number;

    @Column("int", {
        name: "no_of_units"
    })
    noOfUnits: number;

    @Column("varchar", {
        nullable: true,
        name: "insurance"
    })
    insurance: string;

    @Column("datetime", {
        nullable: true,
        name: "insurance_date"
    })
    insuranceDate: any;

    // @Column("varchar", {
    //     nullable: true,
    //     name: "manufacturer"
    // })
    // manufacturer: string;

    // @Column({
    //     type: 'enum',
    //     enum: SiteWarehouse,
    //     nullable: true,
    //     default: SiteWarehouse.SITE,
    //     name: 'site_warehouse'
    // })
    // siteWarehouse: SiteWarehouse;

    @Column("varchar", {
        nullable: true,
        name: "model"
    })
    // model: SiteWarehouse;
    model: string;

    @Column("datetime", {
        nullable: true,
        name: "year"
    })
    year: Date;

    @Column("varchar", {
        name: "asset_supplier"
    })
    assetSupplier: string;

    @Column("datetime", {
        nullable: true,
        name: "expired_date"
    })
    expiredDate: Date;

    @Column("varchar", {
        nullable: true,
        name: "asset_cost"
    })
    assetCost: string;

    @Column("datetime", {
        nullable: true,
        name: "date_of_purchased"
    })
    dateOfPurchased: Date;

    @Column("varchar", {
        nullable: true,
        name: "asset_category"
    })
    assetCategory: string;

    @Column("varchar", {
        nullable: true,
        name: "asset_condition"
    })
    assetcondition: string;

    @Column("varchar", {
        nullable: true,
        name: "status"
    })
    status: AssetStatusEnum;

    @Column("varchar", {
        nullable: true,
        name: "units_of_measurements"
    })
    unitsOfMeasurements: string;

    @Column("datetime", {
        nullable: true,
        name: "last_checkin"
    })
    lastCheckIn: Date;

    @Column("datetime", {
        nullable: true,
        name: "last_checkout"
    })
    lastCheckOut: Date;

    @Column("varchar", {
        nullable: true,
        name: "amc_reason"
    })
    amcReason: string;

    @Column("varchar", {
        nullable: true,
        name: "asset_invoice_no"
    })
    invoice: string;

    @Column("varchar", {
        name: "amc_available"
    })
    amc: string;

    @Column("varchar", {
        name: "amc_provider"
    })
    amcProvider: string;

    @Column("varchar", {
        nullable: true,
        name: "name"
    })
    amcname: string;

    @Column("varchar", {
        nullable: true,
        name: "phone_number"
    })
    amcno: string;

    @Column("varchar", {
        name: "warrenty_available"
    })
    warrenty: string;

    @Column("datetime", {
        name: "warrenty_expired_date"
    })
    warrentyExpiredDate: Date;

    @Column('varchar', {
        name: 'owner_of_asset'
    })
    ownerOfAsset: string;

    @Column('varchar', {
        name: 'department'
    })
    department: string;

    @Column('int', {
        name: 'employee_id'
    })
    employeeId: number;

    @Column('datetime', {
        name: 'maintenance_duedate'
    })
    maintenanceDueDate: Date;

    @Column('datetime', {
        name: 'transaction_date'
    })
    transactionDate: Date;

    @Column('varchar', {
        name: 'decommission_approved_by'
    })
    decommissionApprovedBy: string;

    @Column('varchar', {
        name: 'service_tenure'
    })
    serviceTenure: string;

    @Column('varchar', {
        name: 'insurance_provided_by'
    })
    insuranceProvidedBy: string;

    @Column('int', {
        name: 'plant'
    })
    plant: number;

    @Column("boolean", {
        nullable: false,
        name: "is_active",
        default: true
    })
    isActive: boolean | null;
    @Column({
        type: 'varchar',
        name: 'service_status',
    })
    serviceStatus: string;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column("datetime", {
        name: "asset_service_date",
    })
    assetServiceDate: Date;

    @Column("varchar", {
        name: "service_type",
    })
    serviceType: string;
    @Column("enum", {
        nullable: true,
        enum: ServiceFrequency,
        name: "frequency_of_service"
    })
    frequencyOfService: ServiceFrequency;

    @Column("varchar", {
        nullable: true,
        length: 20,
        name: "month"
    })
    month: string;

    @Column("varchar", {
        nullable: true,
        name: "day"
    })
    day: string;

    @Column("varchar", {
        nullable: true,
        name: "asset_rent_tenure_type"
    })
    assetRentTenureType: string;

    @Column("varchar", {
        nullable: true,
        name: "asset_rent_period"
    })
    assetRentPeriod: string;

    @Column("varchar", {
        nullable: true,
        name: "rental_cost_type"
    })
    rentalCostType: string;

    @Column("int", {
        nullable: true,
        name: "rental_cost"
    })
    rentalCost: number;

    @Column("varchar", {
        nullable: true,
        name: "asset_mode"
    })
    assetMode: string;

    @Column("varchar", {
        nullable: true,
        name: "asset_type"
    })
    assetType: string;

    @Column("varchar", {
        nullable: true,
        name: "insurance_reference_number"
    })
    insuranceRefNum: string;

    @Column("varchar", {
        nullable: true,
        name: "license_number"
    })
    licenseNumber: string;

    @Column("varchar", {
        nullable: true,
        name: "manufacturer"
    })
    softAssetManufacturer: string;

    @Column("varchar", {
        nullable: true,
        name: "hosting_info"
    })
    hostingInfo: string;

    @Column("varchar", {
        nullable: true,
        name: "host_type"
    })
    hostType: string;

    @Column("varchar", {
        nullable: true,
        name: "host_address"
    })
    hostAddress: string;

    @Column("varchar", {
        nullable: true,
        name: "location"
    })
    location: string;

    @Column("varchar", {
        nullable: true,
        name: "domain_url"
    })
    domainUrl: string;

    @Column("varchar", {
        nullable: true,
        name: "user_name"
    })
    userName: string;

    @Column("varchar", {
        nullable: true,
        name: "password"
    })
    password: string;

    @Column("varchar",{
        name:'state'
    })
    state: string;

    @Column("varchar",{
        name:'host'
    })
    host: string;

    @Column("varchar",{
        name:'provisioned_space'
    })
    provisionedSpace: string;

    @Column("varchar",{
        name:'used_space'
    })
    usedSpace: string;

    @Column("varchar",{
        name:'compatibility'
    })
    compatibility: string;

    @Column("varchar",{
        name:'memory_size'
    })
    memorySize: string;

    @Column("varchar",{
        name:'cpu'
    })
    cpu: string;

    @Column("varchar",{
        name:'nic'
    })
    nic: string;

    @Column("varchar",{
        name:'vm_ware_version_tool_status'
    })
    vmWareVersionToolStatus: string;

    @Column("varchar",{
        name:'alarm_actions'
    })
    alarmActions: string;

    @OneToMany(() => AssetAssignment, (assetassigmet) => assetassigmet.assetsId)
    assetsAssignment: AssetAssignment[];

    @OneToMany(() => AssetLocationMapping, (assetLocation) => assetLocation.assetsId)
    assetsLocation: AssetLocationMapping[];

    @OneToMany(() => AssetMaintainance, (assetMaintainance) => assetMaintainance.assetsId)
    assetMaintainance: AssetMaintainance[];

    // @ManyToOne(type => AssetsClassification, assetsClassification => assetsClassification.openAssetsInfo, { nullable: false, })
    // @JoinColumn({ name: "assets_classification_id" })
    // AssetsClassificationInfo: AssetsClassification;

    // @ManyToOne(type => AssetsCatagory, assetsCatagory => assetsCatagory.openAssetsInfo, { nullable: false, })
    // @JoinColumn({ name: "assets_catagory_id" })
    // AssetsCatagoryInfo: AssetsCatagory;

    // @ManyToOne(type => AssetsSubCatagory, assetsSubCatagory => assetsSubCatagory.openAssetsInfo, { nullable: false, })
    // @JoinColumn({ name: "assets_catagory_id" })
    // AssetsSubCatagoryInfo: AssetsSubCatagory;
}